// K6 — önceki yıla göre olağan dışı değer uyarısı: form kopyasının TEK kaynağı.
// KPI hücre editörü kopyası `KPI_COPY.cell.outlier` / `KPI_COPY.portal.outlier`'dadır.

import { outlierDisplayNumber } from "@mahir/shared";

/** tr-TR biçim; sıfır olmayan küçük sayı "0" görünmez (önemli basamak yedeği). */
const num = (n: number): string => outlierDisplayNumber(n, n.toLocaleString("tr-TR"));

export const OUTLIER_COPY = {
  /** Danışman formu (FormFill) — `numeric` soru, giriş kutusunun altında amber satır. */
  form: (year: string, prior: number, value: number, ratio: string): string =>
    `Önceki yıla göre olağan dışı: ${year} yanıtı ${num(prior)}, bu değer ${num(value)} (${ratio}). Fazladan sıfır olabilir mi?`,
} as const;
